import { Box, SectionDivider } from '@domain-group/suit-theme'

import type { ActivityModel } from '@models/types'

import Change from './Change'
import PriceListParameters from './PriceListParameters'

interface ParametersProps {
  activity: ActivityModel,
  isPriceListActivity: boolean,
}

const Parameters = (props: ParametersProps) => {
  const {
    activity,
    activity: { parameters },
    isPriceListActivity,
  } = props

  const { changes = {} } = parameters || {}

  const changeKeys = Object.keys(changes)

  return (
    <>
      <SectionDivider boxProps={{ marginBottom: 'large' }}>CHANGES</SectionDivider>

      <Box
        flexDirection="column"
        maxHeight="300"
        overflowY="auto"
        paddingX="large"
        variant="white"
      >
        {isPriceListActivity && <PriceListParameters activity={activity} />}

        {!isPriceListActivity && changeKeys.map(fieldKey => (
          // @ts-expect-error TS7053
          <Change fieldKey={fieldKey} key={fieldKey} values={changes[fieldKey]} />
        ))}
      </Box>
    </>
  )
}

export default Parameters
